import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Outlet } from 'react-router'

import NavBar from 'components/App/NavBar/Index'

import GlobalStyle from 'components/utils/globalStyles'
import { ErrorBoundary } from 'react-error-boundary'
import FeedbackSidebarForm from 'components/App/FeedbackSidebarForm/Index'
import ErrorPage500 from 'components/App/ErrorPage/ErrorPage500'

const PageWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: auto;
`

const PageWorkspace = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
  position: relative;
`

const ErrorFallback = () => {
  return (
    <ErrorPage500 />
  )
}

const Layout = ({ noNavBar, children, makeError }) => {
  if (makeError) {
    throw new Error('Test unhandled error')
  }

  return (
    <PageWrapper>
      <GlobalStyle />

      {!noNavBar && <NavBar />}

      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <PageWorkspace>
          {!noNavBar && <FeedbackSidebarForm />}
          {children}
          <Outlet />
        </PageWorkspace>
      </ErrorBoundary>
    </PageWrapper>
  )
}

Layout.propTypes = {
  noNavBar: PropTypes.bool,
  makeError: PropTypes.bool,
  children: PropTypes.node,
}

export default Layout
